const menu = [
    {
        key: '/index',
        title: '首页',
        icon: 'home',
        auth: [1]
    },

    // {
    //     title: '其它',
    //     key: '/others',
    //     icon: 'paper-clip',
    //     auth: [1],
    //     subs: [
    //         { title: '上传', key: '/others/upload', icon: '' },
    //         { title: '404', key: '/404', icon: '' },
    //         { title: '500', key: '/500', icon: '' }
    //     ]
    // },
    // {
    //     title: '多级导航',
    //     key: '/one',
    //     icon: 'bars',
    //     subs: [
    //         {
    //             title: '二级',
    //             key: '/one/two',
    //             icon: '',
    //             subs: [{ title: '三级', key: '/one/two/three', icon: '' }]
    //         }
    //     ]
    // },

    {
        title: '任务小类设置',
        key: '/label',
        icon: 'ProfileOutlined',
        auth: [1]
    },
    {
        title: '快捷任务设置',
        key: '/quickTask',
        icon: 'ContainerOutlined',
        auth: [1]
    },
    {
        title: 'VIP卡设置',
        key: '/vipCard',
        icon: 'CreditCardOutlined',
        auth: [1]
    },
    {
        title: '积分卡设置',
        key: '/pointCard',
        icon: 'CreditCardOutlined',
        auth: [1]
    },
    {
        title: '模特类型',
        key: '/modelCategory',
        icon: 'AlignLeftOutlined',
        auth: [1]
    },
    {
        title: '模特名字',
        key: '/modelName',
        icon: 'AlignLeftOutlined',
        auth: [1]
    },
    {
        title: '模特图片',
        key: '/modelPicture',
        icon: 'AlignLeftOutlined',
        auth: [1]
    },
    {
        title: '用户等级设置',
        key: '/memberLevelConfig',
        icon: 'CrownOutlined',
        auth: [1]
    },
    
    
    {
        title: '用户',
        key: '/user',
        icon: 'user',
        auth: [1]
    },
    {
        title: '任务',
        key: '/task',
        icon: 'FundViewOutlined',
        auth: [1]
    },
    {
        title: '订单',
        key: '/order',
        icon: 'AccountBookOutlined',
        auth: [1]
    },
    {
        title: '支付记录',
        key: '/paymentLog',
        icon: 'PayCircleOutlined',
        auth: [1]
    },
    
    
    {
        title: '管理员',
        key: '/admin',
        icon: 'RobotOutlined',
        auth: [1]
    },
    {
        title: '设置',
        key: '/setting',
        icon: 'SettingOutlined',
        auth: [1]
    },
]

export default menu
